import styled from "styled-components"

export const StyledList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 15px;
`

export const ItemContainer = styled.div`
 display: flex;
 align-items: center;
 gap: 13px;
`

export const ListItem = styled.li`
    color: #222741;
`